let activeDropdown = null;

export function registerOpenDropdown(id, closeFn) {
  if (
    activeDropdown &&
    activeDropdown.id !== id &&
    typeof activeDropdown.closeFn === 'function'
  ) {
    activeDropdown.closeFn();
  }
  activeDropdown = { id, closeFn };
}

export function unregisterOpenDropdown(id) {
  if (activeDropdown && activeDropdown.id === id) {
    activeDropdown = null;
  }
}

export function closeOpenDropdown() {
  if (activeDropdown && typeof activeDropdown.closeFn === 'function') {
    const current = activeDropdown;
    activeDropdown = null;
    current.closeFn();
  }
}

export function __resetDropdownManagerForTests() {
  activeDropdown = null;
}
